import React from "react";
import LegalLayout from "@/components/site/LegalLayout";

const Section = ({ title, children }) => (
  <section className="space-y-3">
    <h2 className="font-outfit text-2xl md:text-3xl font-medium text-white">
      {title}
    </h2>
    <div className="space-y-3 text-white/70">{children}</div>
  </section>
);

export default function MentionsLegales() {
  return (
    <LegalLayout kicker="Légal" title="Mentions légales">
      <p>
        Les présentes mentions légales définissent les conditions
        d&rsquo;utilisation du site emgroupdigital.com (ci-après «&nbsp;le
        Site&nbsp;») édité par EM Group.
      </p>

      <Section title="1. Éditeur du site">
        <p>
          <span className="text-white">Raison sociale :</span> EM Group
          <br />
          <span className="text-white">Forme juridique :</span> Cabinet de
          conseil digital
          <br />
          <span className="text-white">Siège social :</span> 60 rue François
          1<sup>er</sup>, 75008 Paris — France
          <br />
          <span className="text-white">Email :</span>{" "}
          <a
            href="mailto:contact@emgroupdigital.com"
            className="text-[#E52431] hover:underline"
          >
            contact@emgroupdigital.com
          </a>
          <br />
          <span className="text-white">Téléphone :</span>{" "}
          <a
            href="tel:+262262667970"
            className="text-[#E52431] hover:underline"
          >
            +262&nbsp;262&nbsp;66&nbsp;79&nbsp;70
          </a>
          <br />
          <span className="text-white">WhatsApp :</span>{" "}
          <a
            href="https://wa.me/262693482110"
            target="_blank"
            rel="noreferrer"
            className="text-[#E52431] hover:underline"
          >
            +262&nbsp;693&nbsp;48&nbsp;21&nbsp;10
          </a>
        </p>
        <p className="text-sm text-white/55">
          SIRET, RCS et numéro de TVA intracommunautaire communiqués sur
          demande.
        </p>
      </Section>

      <Section title="2. Directeur de la publication">
        <p>Le Directeur de la publication est le représentant légal d&rsquo;EM Group.</p>
      </Section>

      <Section title="3. Hébergement">
        <p>
          Le Site est hébergé sur une infrastructure cloud sécurisée
          répondant aux standards du RGPD. Les coordonnées détaillées de
          l&rsquo;hébergeur peuvent être communiquées sur demande écrite à{" "}
          <a
            href="mailto:contact@emgroupdigital.com"
            className="text-[#E52431] hover:underline"
          >
            contact@emgroupdigital.com
          </a>
          .
        </p>
      </Section>

      <Section title="4. Propriété intellectuelle">
        <p>
          L&rsquo;ensemble du contenu présent sur le Site (textes, visuels,
          logos, marques, illustrations, charte graphique, code source) est
          la propriété exclusive d&rsquo;EM Group ou de ses partenaires, et
          est protégé par les lois en vigueur relatives à la propriété
          intellectuelle.
        </p>
        <p>
          Toute reproduction, représentation, modification ou adaptation,
          totale ou partielle, par quelque procédé que ce soit, sans
          autorisation écrite préalable d&rsquo;EM Group, est strictement
          interdite et constitue un délit de contrefaçon sanctionné par le
          Code de la propriété intellectuelle.
        </p>
      </Section>

      <Section title="5. Données personnelles">
        <p>
          Les informations recueillies via les formulaires du Site sont
          traitées conformément à notre{" "}
          <a href="/confidentialite" className="text-[#E52431] hover:underline">
            Politique de confidentialité
          </a>
          . Conformément au RGPD, vous disposez d&rsquo;un droit
          d&rsquo;accès, de rectification, d&rsquo;opposition et de
          suppression de vos données.
        </p>
      </Section>

      <Section title="6. Cookies">
        <p>
          Le Site utilise des cookies strictement nécessaires à son bon
          fonctionnement ainsi que, le cas échéant, des cookies de mesure
          d&rsquo;audience. Vous pouvez à tout moment configurer votre
          navigateur pour refuser les cookies.
        </p>
      </Section>

      <Section title="7. Responsabilité">
        <p>
          EM Group met tout en œuvre pour assurer l&rsquo;exactitude des
          informations diffusées sur le Site. Toutefois, EM Group ne peut
          être tenu responsable des erreurs, omissions ou des éventuelles
          interruptions de service liées à des opérations de maintenance ou
          à des cas de force majeure.
        </p>
      </Section>

      <Section title="8. Droit applicable">
        <p>
          Les présentes mentions légales sont régies par le droit français.
          Tout litige relatif à leur interprétation ou à leur exécution
          relèvera de la compétence exclusive des tribunaux du ressort du
          siège social d&rsquo;EM Group.
        </p>
      </Section>
    </LegalLayout>
  );
}
